import { render, staticRenderFns } from "./Ylj.vue?vue&type=template&id=7abc4588&scoped=true&"
import script from "./Ylj.vue?vue&type=script&lang=js&"
export * from "./Ylj.vue?vue&type=script&lang=js&"
import style0 from "./Ylj.vue?vue&type=style&index=0&id=7abc4588&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abc4588",
  null
  
)

export default component.exports